import { render } from "./P035.vue?vue&type=template&id=c159e57e&scoped=true"
import script from "./P035.vue?vue&type=script&lang=js"
export * from "./P035.vue?vue&type=script&lang=js"

import "./P035.vue?vue&type=style&index=0&id=c159e57e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c159e57e"]])

export default __exports__